import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SplashScreen from "../elements/splashScreen/splashScreen.render.jsx";
import * as settingAction from "../../reduxStore/actions/settings";
import * as mainAction from "../../reduxStore/actions/main";
import * as navigationAction from "../../reduxStore/actions/navigation.js";
import RouteWithSubRoutes from "../../app/RouteWithSubRoutes";
import { Redirect, Switch } from "react-router-dom";
import SaveZoneWrapper from "../elements/wrapper/saveZone.wrapper.jsx";
import { hideNativeLoadingScreen } from "../nativeAppInterface/NativeAppInterface.jsx";
import { setProperties } from "../../reduxStore/actions/settings";
import { indicatorLog } from "../../functions/helper/helpers.functions.js";
import { statisticLogger } from "../statisticLogger/StatisticLogger.container.js";
import { pageNames } from "../../reduxStore/reducers/main.js";
import { catchupKey } from "./pages/login/Welcom.page.jsx";

function Intro(props) {
  const { page, start, destination, campusKeys } = getURLParams(
    props.match.params
  );
  const [startValue] = useState(start);
  const [destinationValue] = useState(destination);
  const [campusKeysValue] = useState(campusKeys);
  const [pageValue] = useState(page);
  const [skipCampusSelection, setSkipCampusSelection] = useState(false);

  useEffect(() => {
    if (!props.userGroup) return;

    if (campusKeys) {
      const keys = campusKeys.split(",");
      if (keys.length) {
        setSkipCampusSelection(true);
        loadCampuses(keys, props.userGroup);
      }
    } else {
      if (props.campuses?.length) {
        indicatorLog("Campus Keys wurden erhalten 🔑");
      } else {
        indicatorLog("Campus Keys konnten nicht geladen werden", {
          background: "red",
        });
      }
      if (1 === props?.campuses?.length) {
        setSkipCampusSelection(true);
        loadCampuses([props.campuses[0].campusKey], props.userGroup);
      }
    }

    hideNativeLoadingScreen();
  }, [props.campuses, props.userGroup]);

  const loadCampuses = (keys, userGroup) => {
    props.loadCampuses(keys, props.language, userGroup);
    props.setCampusKeys(keys);
  };

  useEffect(() => {
    if (statisticLogger) {
      statisticLogger.currentPage = pageNames.intro;
    }
  }, []);

  const transmittedProps = {
    ...props,
    skipCampusSelection,
    loadCampuses,
    setGPSData: props.setGPSData,
    setLocationPermissionAllowed: props.setLocationPermissionAllowed,
    page: pageValue ? pageValue : "info",
    start: startValue,
    destination: destinationValue,
    campusKeys: campusKeysValue,
    locationObject: props.locationObject,
  };

  return (
    <SplashScreen
      className={
        props.history?.location?.pathname ===
        `/${pageNames.intro}/${pageNames.login}/`
          ? "corporateBackground"
          : ""
      }
      animated={false}
      render={() => (
        <SaveZoneWrapper>
          <div className={"position-relative h-100 overflow-hidden"}>
            <Switch>
              {props.routes.map((route, i) => (
                <RouteWithSubRoutes
                  props={transmittedProps}
                  key={i}
                  {...route}
                />
              ))}
              <Redirect
                strict={true}
                to={`/${pageNames.intro}/${
                  // wenn auf intro verwiesen wird und es handelt sich um die catchup instanz
                  // dann soll vorerst auf den login verwiesen werden!
                  props.piKeyState && props.piKeyState !== catchupKey
                    ? pageNames.selectLanguage
                    : pageNames.login
                }/${window.location.search.replace("/", "")}`}
              />
            </Switch>
          </div>
        </SaveZoneWrapper>
      )}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    userGroup: state.settings.routing.userGroup,
    language: state.main.language,
    campuses: state.main.availableCampuses,
    isApp: state.main.isApp,
    serverDataLoaded: state.main.serverDataLoaded,
    userAllowedGPS: state.settings.location.userAllowed,
    properties: state.settings,
    locationObject: state.route.locationObject,
    locationPermissionAllowed: state.settings.location.permissionAllowed,
    activeStatus: state.route.activeStatus,
    activeStatusPermission: state.route.activeStatusPermission,
    piKeyState: state.main.piKeyState,
    loginPiKeys: state.main.loginPiKeys,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLanguage: (key) => dispatch(mainAction.setLanguage(key)),
    loadCampuses: (keys, lang, piKey) =>
      dispatch(mainAction.loadCampuses(keys, lang, piKey)),
    setLocationPermissionAllowed: (value) =>
      dispatch(setProperties({ location: { permissionAllowed: value } })),
    setCampusKeys: (keys) => dispatch(mainAction.setCampusKeys(keys)),
    setUserAllowedGPS: (allowed) =>
      dispatch(setProperties({ location: { userAllowed: allowed } })),
    setGPSData: (data) => dispatch(navigationAction.setGPSData(data)),
    setProperty: (property, value) =>
      dispatch(settingAction.setProperty(property, value)),
    setProperties: (object) => dispatch(settingAction.setProperties(object)),
    toggleSetting: (name) => dispatch(settingAction.toggleRoutingSetting(name)),
    completeIntro: (value) => dispatch(mainAction.completeIntro(value)),
    setPiKeyState: (piKey) => dispatch(mainAction.setPiKeyState(piKey)),
    setLoginPiKeys: (piKeys) => dispatch(mainAction.setLoginPiKeys(piKeys)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Intro);

function getURLParams(params) {
  // this is the case, if user reload this page in intro
  if (
    "select-language" === params.piKey ||
    "select-campus" === params.piKey ||
    "select-location" === params.piKey ||
    "select-push" === params.piKey ||
    "select-push" === params.piKey ||
    "select-restrictions" === params.piKey ||
    "select-user-group" === params.piKey ||
    "complete" === params.piKey
  ) {
    return {
      campusKeys: "",
      destination: null,
      page: params.piKey,
      piKey: params.page,
      start: null,
    };
  }

  return params;
}
